import React, { useEffect } from "react";
import styled, { css, RuleSet } from "styled-components";
import { LoginProps } from "../../types/loginTypes";
import { MESSAGES } from "../../messages";
import { useLogin } from "../../hooks/useLogin";
import { pulseDarker } from "../../components/tables/LoadingTableCell";

const LoginButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

const Button = styled.button<{ isLoading?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dbdade;
  color: black;
  width: 100%;
  height: 65px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #20e290;
  }
  ${({ isLoading }): false | RuleSet<object> | undefined =>
    isLoading &&
    css`
      animation: ${pulseDarker} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    `}
`;

const LoginButtonMessage = styled.span`
  display: flex;
  justify-content: center;
`;

export const LoginButton: React.FC<LoginProps> = ({
  usernameProps,
  passwordProps,
  loginErrorProps,
}) => {
  const { username } = usernameProps;
  const { password } = passwordProps;
  const { setError } = loginErrorProps;

  const { handleLogin, isLoading, error } = useLogin();

  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [error]);

  return (
    <LoginButtonContainer>
      <Button
        isLoading={isLoading}
        onClick={(): Promise<void> => handleLogin(username, password, setError)}
      >
        <LoginButtonMessage>{MESSAGES.ACCESS_TO_COMPASS}</LoginButtonMessage>
      </Button>
    </LoginButtonContainer>
  );
};
